import React, { useEffect, useState  } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContactForm from '../components/ContactForm'; 
import RoomsSection from '../components/RoomsSection'; 
import TestimonialSlider from '../components/TestimonialSlider'; 
import GallerySlider from '../components/GallerySlider'; 
import Slideshow from '../components/Slideshow'; 
import Header from '../components/header'; 
import Footer from '../components/footer'; 
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_CATEGORIES = `${BASE_URL}admin/getdata/get_roomcategory.php`;

const API_ROOMS = `${BASE_URL}getpagedata/get_roomlist_home.php`;
const ROOM_IMG = `${BASE_URL}admin/assets/room_gallery/`;
const ENQUIRY = `${BASE_URL}getpagedata/save-enquiry.php`;

const Home = () => {
const [categories, setCategories] = useState([]);
const [selectedCategoryId, setSelectedCategoryId] = useState(null);

const [roomList, setRoomList] = useState([]);
const [roomLoading, setRoomLoading] = useState(true);
const [error, setError] = useState(null);

const navigate = useNavigate();

const [checkin, setCheckin] = useState("");
const [checkout, setCheckout] = useState("");
const [adults, setAdults] = useState("1");
const [children, setChildren] = useState("0");
const [roomCount, setRoomCount] = useState("1");


const fetchAll = async () => {
  try {

    const c = await axios.get(API_CATEGORIES);
    setCategories(c.data || []);

    if (c.data && c.data.length > 0) {
      setSelectedCategoryId(c.data[0].room_id);
    }

    const r = await axios.get(API_ROOMS);

    if (r.data.status && Array.isArray(r.data.data)) {
      setRoomList(r.data.data);
    } else {
      setRoomList([]);
    }

  } catch (err) {
    console.error(err);
    setError("Unable to load rooms.");
  }

  setRoomLoading(false);
};

  const [form, setForm] = useState({
    fullname: "",
    email: "",
    contact: "",
    address: "",
    message: ""
  });

  const [enquiryLoading, setEnquiryLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };



  useEffect(() => {
    fetchAll();
  }, []);

  // -------------------------
  // HANDLE ENQUIRY SUBMIT
  // -------------------------
  const handleSubmit = async () => {

    if (!form.fullname || !form.email || !form.contact) {
      alert("Please fill required fields");
      return;
    }

    setEnquiryLoading(true);

    try {
      const res = await fetch(ENQUIRY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Enquiry submitted successfully!");

        setForm({
          fullname: "",
          email: "",
          contact: "",
          address: "",
          message: ""
        });

      } else {
        alert("Error saving enquiry");
      }

    } catch (err) {
      console.error(err);
      alert("Server error");
    }

    setEnquiryLoading(false);
  };


  return (
    <div>
        <Header />
  		 
    <div className="section background-dark over-hide hhgt">

        <div className="hero-center-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-10 col-sm-8 parallax-fade-top" style={{ paddingTop: "10px" }}>
                        <div className="hero-text">Rourkela’s Premier Hub for Stays & Events</div>
                    </div>
                    <div className="col-12 mb-1 parallax-fade-top">
                        <div className="hero-stars">
                            <i className="fa fa-star-o"></i>
                            <i className="fa fa-star-o"></i>
                            <i className="fa fa-star-o"></i>
                            <i className="fa fa-star-o"></i>
                            <i className="fa fa-star-o"></i>
                        </div>
                    </div>
                    <div className="col-12 parallax-fade-top" style={{ paddingTop: "30px" }}>
                     <div className="booking-hero-wrap padd">
                         <div className="row justify-content-center g-3 ">

                            {/* CHECK-IN */}
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-item">
                                <span className="fontawesome-calendar"></span>
                                <label>Check In</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={checkin}
                                    min={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                    setCheckin(e.target.value);
                                    setCheckout("");
                                    }}
                                />
                                </div>
                            </div>

                            {/* CHECK-OUT */}
                            <div className="col-12 col-md-6 col-lg-3 g-3">
                                <div className="form-item">
                                <span className="fontawesome-calendar"></span>
                                 <label>Check Out</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={checkout}
                                    min={checkin || new Date().toISOString().split("T")[0]}
                                    onChange={(e) => setCheckout(e.target.value)}
                                />
                                </div>
                            </div>

                            {/* ADULTS */}
                            <div className="col-4 col-md-2 col-lg-1 g-3">
                                <label>Adult</label>
                                <select
                                className="form-control"
                                value={adults}
                                onChange={(e) => setAdults(e.target.value)}
                                >
                                {[0,1,2,3,4,5].map(num => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                                </select>
                            </div>

                            {/* CHILDREN */}
                            <div className="col-4 col-md-2 col-lg-1 g-3">
                                 <label>Children</label>
                                <select
                                className="form-control"
                                value={children}
                                onChange={(e) => setChildren(e.target.value)}
                                >
                                {[0,1,2,3,4].map(num => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                                </select>
                            </div>

                            {/* ROOMS */}
                            <div className="col-4 col-md-2 col-lg-2 g-3">
                                 <label>Room</label>
                                <select
                                className="form-control"
                               value={roomCount}
                                onChange={(e) => setRoomCount(e.target.value)}
                                >
                                {[1,2,3].map(num => (
                                    <option key={num} value={num}>{num} Room{num > 1 && "s"}</option>
                                ))}
                                </select>
                            </div>

                            {/* BOOK NOW */}
                            <div className="col-12 col-md-4 col-lg-2 g-3">
                                <br></br>
                                <button
                                className="booking-button w-100"
                                onClick={() => {
                                    if (!checkin || !checkout) {
                                    alert("Please select dates");
                                    return;
                                    }
                                    if (checkout <= checkin) {
                                    alert("Check-out must be after check-in");
                                    return;
                                    }

                                    navigate(
                                    `/room-checkout?room_id=${selectedCategoryId}&checkin=${checkin}&checkout=${checkout}&adults=${adults}&children=${children}&rooms=${roomCount}`
                                    );
                                }}
                                >
                                Book Now
                                </button>
                            </div>

                            </div>
                    </div>
                    </div>

                </div>
               
            </div>
        </div>

        <Slideshow />
    </div>
     <div className="section over-hide" style={{ paddingTop: "30px", paddingRight: "10px", paddingLeft: "10px" }}>
             <div className="container">
            <div className="row">
                 <div className="col-md-12 align-self-center">
                 <div className="booking-hero-wrap mobpadd" style={{paddingRight: "5px", paddingLeft: "5px", background: "rgb(194, 247, 222)" }}>
                         <div className="row justify-content-center g-3 ">

                            {/* CHECK-IN */}
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-item">
                                <span className="fontawesome-calendar"></span>
                                <label>Check In</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={checkin}
                                    min={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                    setCheckin(e.target.value);
                                    setCheckout("");
                                    }}
                                />
                                </div>
                            </div>

                            {/* CHECK-OUT */}
                            <div className="col-12 col-md-6 col-lg-3 g-3">
                                <div className="form-item">
                                <span className="fontawesome-calendar"></span>
                                 <label>Check Out</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={checkout}
                                    min={checkin || new Date().toISOString().split("T")[0]}
                                    onChange={(e) => setCheckout(e.target.value)}
                                />
                                </div>
                            </div>

                            {/* ADULTS */}
                            <div className="col-4 col-md-2 col-lg-1 g-3">
                                <label>Adult</label>
                                <select
                                className="form-control"
                                value={adults}
                                onChange={(e) => setAdults(e.target.value)}
                                >
                                {[0,1,2,3,4,5].map(num => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                                </select>
                            </div>

                            {/* CHILDREN */}
                            <div className="col-4 col-md-2 col-lg-1 g-3">
                                 <label>Children</label>
                                <select
                                className="form-control"
                                value={children}
                                onChange={(e) => setChildren(e.target.value)}
                                >
                                {[0,1,2,3,4].map(num => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                                </select>
                            </div>

                            {/* ROOMS */}
                            <div className="col-4 col-md-2 col-lg-2 g-3">
                                 <label>Room</label>
                                <select
                                className="form-control"
                               value={roomCount}
                                onChange={(e) => setRoomCount(e.target.value)}
                                >
                                {[1,2,3].map(num => (
                                    <option key={num} value={num}>{num} Room{num > 1 && "s"}</option>
                                ))}
                                </select>
                            </div>

                            {/* BOOK NOW */}
                            <div className="col-12 col-md-4 col-lg-2 g-3">
                                <br></br>
                                <button
                                className="booking-button w-100"
                                onClick={() => {
                                    if (!checkin || !checkout) {
                                    alert("Please select dates");
                                    return;
                                    }
                                    if (checkout <= checkin) {
                                    alert("Check-out must be after check-in");
                                    return;
                                    }

                                    navigate(
                                    `/room-checkout?room_id=${selectedCategoryId}&checkin=${checkin}&checkout=${checkout}&adults=${adults}&children=${children}&rooms=${roomCount}`
                                    );
                                }}
                                >
                                Book Now
                                </button>
                            </div>

                            </div>
                    </div>
                </div>
            </div>
            </div>
    </div>

    <div className="section padding-top-bottom over-hide">
        <div className="container">
            
            <div className="row">
                <div className="col-md-7 align-self-center">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <div className="subtitle text-center mb-4">Best Hotel in Rourkela</div>
                            <h2 className="text-justify">Welcome to Hotel Pahadi Convention</h2>
                            <p className="text-justify mt-5">Experience comfort, elegance, and impeccable hospitality at Hotel Pahadi Convention, one of the best hotels in Rourkela for premium stays, events, and conventions. Our well-appointed guest rooms offer modern amenities including air-conditioning, 24/7 room service, and hot & cold water for a relaxing stay. Enjoy delicious multi-cuisine dishes at our in-house restaurant, crafted to delight every palate. For corporate meetings, social gatherings, and grand events, our fully equipped conference and banquet halls provide the perfect venue with advanced facilities and seamless arrangements. Whether you're visiting for business, celebrations, or leisure, Hotel Pahadi Convention promises a luxurious and memorable hospitality experience in Rourkela.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-5 mt-4 mt-md-0">
                    <div className="img-wrap">
                        <img src="/img/rooms.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>

   <RoomsSection />

    <div className="section background-dark over-hide">
        <div className="container-fluid py-4">
            <div className="row">
                <div className="col-sm-6 col-lg-4">
                    <a href="/rooms">
                        <div className="img-wrap services-wrap">
                            <img src="/img/ser1.png" alt="" />
                            <div className="services-text-over">Rooms</div>
                        </div>
                    </a>
                </div>
                <div className="col-sm-6 col-lg-4 pt-4 pt-sm-0">
                    <a href="/dinein">
                        <div className="img-wrap services-wrap">
                            <img src="/img/ser2.png" alt="" />
                            <div className="services-text-over">restaurant</div>
                        </div>
                    </a>
                </div>
               
                <div className="col-sm-6 col-lg-4 pt-4 pt-lg-0">
                    <a href="/banquet">
                        <div className="img-wrap services-wrap">
                            <img src="/img/ser4.png" alt="" />
                            <div className="services-text-over">Banquet</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div className="section padding-top-bottom over-hide">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 align-self-center">
                    <div className="subtitle with-line text-center mb-4">Experience Exceptional Services</div>
                    <h3 className="text-center padding-bottom-small"> At Our Hotel In Rourkela</h3>
                </div>
                <div className="section clearfix"></div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="/img/icons/booking.png" alt=""/>
                        <h5 className="mt-1">No Booking fees</h5>
                        <p className="mt-3 text-justify">Enjoy complete transparency with our no booking fees policy, ensuring you pay only for your stay without any hidden or extra charges.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="/img/icons/best-price.png" alt="" />
                        <h5 className="mt-1">Best rate guarantee</h5>
                        <p className="mt-3  text-justify">Benefit from our best rate guarantee, offering you the most competitive prices and unmatched value whenever you book directly with us.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="/img/icons/reservation.png" alt="" />
                        <h5 className="mt-1">Reservation 24/7</h5>
                        <p className="mt-3  text-justify">Enjoy round-the-clock reservation support, allowing you to book your stay anytime with ease, convenience, and reliable assistance whenever you need it.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="/img/icons/wifi.png" alt="" />
                        <h5 className="mt-1">High Speed WIFI</h5>
                        <p className="mt-3  text-justify">Stay connected with our high-speed Wi-Fi, offering seamless browsing, smooth streaming, and uninterrupted access throughout your entire stay.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="/img/6.svg" alt="" />
                        <h5 className="mt-2">Dining</h5>
                        <p className="mt-3  text-justify">Savor a delightful dining experience with freshly prepared dishes, rich flavors, and a welcoming ambiance crafted to satisfy every palate.</p>
                       
                    </div>
                </div>
                  <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center cll">
                        <img src="/img/icons/no-smoking.png" alt="" />
                        <h5 className="mt-2">No Smoking</h5>
                        <p className="mt-3  text-justify">Savor a delightful dining experience with freshly prepared dishes, rich flavors, and a welcoming ambiance crafted to satisfy every palate.</p>
                       
                    </div>
                </div>
               
                 
            </div>
        </div>
    </div>

    <div className="section padding-top-bottom-big over-hide">
        <div className="parallax" style={{ backgroundImage: `url('/img/4.jpg')` }}></div>
        <div className="section z-bigger">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row justify-content-center">
                              <div className="booking-hero-wrap padd">
                         <div className="row justify-content-center g-3 ">

                            {/* CHECK-IN */}
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-item">
                                <span className="fontawesome-calendar"></span>
                                <label>Check In</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={checkin}
                                    min={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                    setCheckin(e.target.value);
                                    setCheckout("");
                                    }}
                                />
                                </div>
                            </div>

                            {/* CHECK-OUT */}
                            <div className="col-12 col-md-6 col-lg-3 g-3">
                                <div className="form-item">
                                <span className="fontawesome-calendar"></span>
                                 <label>Check Out</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={checkout}
                                    min={checkin || new Date().toISOString().split("T")[0]}
                                    onChange={(e) => setCheckout(e.target.value)}
                                />
                                </div>
                            </div>

                            {/* ADULTS */}
                            <div className="col-4 col-md-2 col-lg-1 g-3">
                                <label>Adult</label>
                                <select
                                className="form-control"
                                value={adults}
                                onChange={(e) => setAdults(e.target.value)}
                                >
                                {[0,1,2,3,4,5].map(num => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                                </select>
                            </div>

                            {/* CHILDREN */}
                            <div className="col-4 col-md-2 col-lg-1 g-3">
                                 <label>Children</label>
                                <select
                                className="form-control"
                                value={children}
                                onChange={(e) => setChildren(e.target.value)}
                                >
                                {[0,1,2,3,4].map(num => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                                </select>
                            </div>

                            {/* ROOMS */}
                            <div className="col-4 col-md-2 col-lg-2 g-3">
                                 <label>Room</label>
                                <select
                                className="form-control"
                               value={roomCount}
                                onChange={(e) => setRoomCount(e.target.value)}
                                >
                                {[1,2,3].map(num => (
                                    <option key={num} value={num}>{num} Room{num > 1 && "s"}</option>
                                ))}
                                </select>
                            </div>

                            {/* BOOK NOW */}
                            <div className="col-12 col-md-4 col-lg-2 g-3">
                                <br></br>
                                <button
                                className="booking-button w-100"
                                onClick={() => {
                                    if (!checkin || !checkout) {
                                    alert("Please select dates");
                                    return;
                                    }
                                    if (checkout <= checkin) {
                                    alert("Check-out must be after check-in");
                                    return;
                                    }

                                    navigate(
                                    `/room-checkout?room_id=${selectedCategoryId}&checkin=${checkin}&checkout=${checkout}&adults=${adults}&children=${children}&rooms=${roomCount}`
                                    );
                                }}
                                >
                                Book Now
                                </button>
                            </div>

                            </div>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

     <div className="container py-5">
{roomLoading && <p>Loading rooms...</p>}
      {error && <p className="text-danger">{error}</p>}
      
    {roomList.map(room => {
     const amenities = room.amenities
    ? room.amenities.split(",").map(a => a.trim())
    : [];

        return (
          <div className="card booking-list-card mb-4" key={room.id}>
            <div className="row g-0">

              {/* IMAGE */}
              <div className="col-lg-3">
                <img
                    src={`${ROOM_IMG}${room.room_image || "default.jpg"}`}
                  className="img-fluid w-100 list-img"
                  alt={room.name}
                />
              </div>

              {/* DETAILS */}
              <div className="col-lg-6 p-4 d-flex flex-column">

                <div className="d-flex justify-content-between">
                  <h5 className="property-title">{room.name}</h5>
                 <div className="hotel-rating">5 ★</div>
                </div>

                 <div className="small text-muted mb-3" style={{ fontWeight: "bold" }}>
                  Free Cancellation available
                </div>

                <div className="small mb-3" dangerouslySetInnerHTML={{ __html: room?.description || "" }}>
                </div>

                <div className="mt-auto text-success small">
                 {amenities.map((a, index) => (
                  <span key={index} className="me-3">
                   &nbsp; <i className="bi bi-check-circle"></i> &nbsp;
                    {typeof a === "string" ? a.trim() : a.name}
                  </span>
                ))}
                </div>
              </div>

              {/* PRICE */}
              <div className="col-lg-3 p-4 d-flex flex-column justify-content-between text-end bg-light">

                <div>
                  <small className="text-muted">
                    1 night • 1 adults
                  </small>
                  <h4 className="text-danger">Rs.{room.price}</h4>
                  <small className="text-muted">
                    Includes taxes & fees
                  </small>
                </div>

                <div>
                 <button
                    className="btn btn-primary w-100"
                    onClick={() =>
                    navigate(`/room-checkout?room_id=${room.room_id}`)
                    }
                    >See Availability</button>        
                </div>

                  <div>
               <button
              className="btn btn-primary w-100"
              data-bs-toggle="modal"
              data-bs-target="#enquiryModal"
            >
              Quick Enquiry
            </button>   
              
                </div>
              </div>
               
            </div>
            
          </div>
          
        );
      })}

</div>
 <div className="modal fade" id="enquiryModal" tabIndex="-1">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content shadow-lg border-0 rounded-4">

      <div className="modal-header bg-dark text-white rounded-top-4">
        <h5 className="modal-title">Hotel Enquiry</h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <div className="modal-body p-4">

        <div className="row g-3">

          <div className="col-md-6">
            <input
              type="text"
              name="fullname"
              placeholder="Full Name *"
              className="form-control"
              value={form.fullname}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <input
              type="email"
              name="email"
              placeholder="Email *"
              className="form-control"
              value={form.email}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <input
              type="tel"
              name="contact"
              placeholder="Contact No *"
              className="form-control"
              pattern="[0-9]{10}"
              value={form.contact}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <input
              type="text"
              name="address"
              placeholder="Address"
              className="form-control"
              value={form.address}
              onChange={handleChange}
            />
          </div>

          <div className="col-12">
            <textarea
              name="message"
              rows="4"
              placeholder="Your Message"
              className="form-control"
              value={form.message}
              onChange={handleChange}
            ></textarea>
          </div>

        </div>

      </div>

      <div className="modal-footer">
        <button
          className="btn btn-dark w-100"
          onClick={handleSubmit}
          disabled={enquiryLoading}
        >
          {enquiryLoading ? "Submitting..." : "Submit Enquiry"}
        </button>
      </div>

    </div>
  </div>
</div>
    <div className="section padding-top-bottom over-hide background-grey">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 align-self-center">
                    <div className="subtitle with-line text-center mb-4">Testimonials</div>
                    <h3 className="text-center">What Customer say</h3>
                </div>
            </div>
        </div>
    </div>

<div className="section padding-top-bottom-big over-hide">
		<div className="parallax" style={{ backgroundImage: `url('/img/4.jpg')` }}></div>
		<TestimonialSlider />
	</div>
    <div className="section padding-top-bottom background-grey over-hide">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 align-self-center">
                    <div className="subtitle with-line text-center mb-4">Excellent restaurant</div>
                    <h3 className="text-center padding-bottom-small">Kitchen &amp; Restaurant</h3>
                </div>
                <div className="section clearfix"></div>
            </div>
            <div className="row background-white p-0 m-0">
                <div className="col-xl-6 p-0">
                    <div className="img-wrap" id="rev-3">
                        <img src="/img/17.jpeg" alt=""/>
                    </div>
                </div>
                <div className="col-xl-6 p-0 align-self-center">
                    <div className="row justify-content-center">
                        <div className="col-9 pt-4 pt-xl-0 pb-5 pb-xl-0 text-center">
                            <h5 className="">Our Kitchen</h5>
                            <p className="mt-3 text-justify">Our kitchen brings together fresh ingredients and skilled preparation to deliver flavorful, wholesome dishes crafted with care.</p>
                            <a className="mt-1 btn btn-primary" href="/dinein">explore</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row background-white p-0 m-0">
                <div className="col-xl-6 p-0 align-self-center">
                    <div className="row justify-content-center">
                        <div className="col-9 pt-4 pt-xl-0 pb-5 pb-xl-0 text-center">
                            <h5 className="">Our Dining</h5>
                            <p className="mt-3 text-justify">Experience delightful dining with a variety of freshly prepared dishes, where rich flavors and warm hospitality come together beautifully.</p>
                            <a className="mt-1 btn btn-primary" href="/dinein">explore</a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 order-first order-xl-last p-0">
                    <div className="img-wrap" id="rev-4">
                        <img src="/img/27.jpeg" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="contact-section py-5">
    <div className="container">
        <div className="row justify-content-center mb-5">
            <div className="col-md-8 text-center">
                <span className="subtitle">Get in Touch</span>
                <h3 className="section-title">We’d Love to Hear From You</h3>
                <p className="section-desc">Reach out for bookings, inquiries, or support anytime.</p>
            </div>
        </div>

        <div className="row g-4">

            
            <div className="col-lg-4">
                <div className="contact-info-card shadow-sm p-4 rounded">
                    <h4 className="mb-4">Contact Details</h4>

                    <div className="info-box mb-3">
                        <i className="fa fa-map-marker"></i>
                        <div>
                            <h6>Address</h6>
                            <p>Hotel Pahadi, Vedvyas, Rourkela, Odisha, India</p>
                        </div>
                    </div>

                    <div className="info-box mb-3">
                        <i className="fa fa-phone"></i>
                        <div>
                            <h6>Phone</h6>
                            <p>+91 9238394006<br/>+91 9692908506</p>
                        </div>
                    </div>

                    <div className="info-box mb-3">
                        <i className="fa fa-envelope-open"></i>
                        <div>
                            <h6>Email</h6>
                            <p>reservations@hotelpahadi.com</p>
                        </div>
                    </div>

                    <div className="info-box mb-3">
                        <i className="fa fa-clock-o"></i>
                        <div>
                            <h6>Working Hours</h6>
                            <p>8:00 AM – 10:00 PM</p>
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="col-lg-8">
                <div className="contact-form-card shadow-sm p-4 rounded">
                    <h4 className="mb-4">Send Us a Message</h4>

                  <ContactForm />
                </div>
            </div>

        </div>

         
        <div className="row justify-content-center text-center mt-5">
            <p><em>For urgent support:</em></p>&nbsp; 
            <h3 className="display-5 fw-bold text-success">+91 9238394006</h3>
        </div>
    </div>
</section>

    <GallerySlider />
    <br></br>
    <Footer />
    </div>
  )
}

export default Home;